<template>
  <div style="margin-top:67px">
    <section class="desktop">
      <div class="cart-wrapper">
        <step :isActiveCart="true"></step>
        <div class="cart-container">
          <b-container>
            <b-row align-h="around" style="align-items:center">
              <b-col cols="6">
                <div class="item">
                  <div v-for="(item, index) in cartItems" :key="index" class="cart-item">
                    <div class="left-item-info">
                      <img style="width: 45px;" :src="item.iconUrl">
                      <span>{{item.name}}</span>
                    </div>
                    <div class="right-item-info">
                      <!-- <span class="bold">{{item.price}}원</span> -->
                      <img
                        class="btn-close"
                        src="@/assets/cart/btn-delete.png"
                        @click="removeItem(item)"
                      >
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col cols="3">
                <div class="item-info">
                  <p class="amount-info">
                    <span>총 체험 금액</span>
                    <span class="bold">0 원</span>
                  </p>
                  <button class="apply" @click="apply">체험 신청하기</button>
                  <div class="description">
                    <span>
                      부담없이 제품을 먼저 써보세요.
                      <br>배송과 반납조차 무료입니다.
                    </span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <suggestion v-show="suggestions.length"></suggestion>
    </section>
    <section class="mobile">
      <step :isActiveCart="true"></step>
      <div class="m-cart-wrapper">
        <div v-for="(item, index) in cartItems" :key="index" class="m-cart-item">
          <div class="m-image-container">
            <img style="width:45px;" :src="item.iconUrl">
          </div>
          <div class="m-mid-item-info">
            <span>{{item.name}}</span>
            <transition name="fade">
              <span style="color: #FF6666" v-if="show">마감 임박</span>
            </transition>
            <!-- <span class="bold">{{item.price}}원</span> -->
          </div>
          <img class="btn-close" src="@/assets/cart/btn-delete.png" @click="removeItem(item)">
        </div>
        <div class="m-item-info">
          <p class="m-amount-info">
            <span>총 체험 금액</span>
            <span>0 원</span>
          </p>
          <p class="m-description">
            부담없이 제품을 먼저 써보세요.
            <br>배송과 반납조차 무료입니다.
          </p>
          <p class="m-description">
            지금
            <countTo
              ref="counter"
              :startVal="0"
              :endVal="endVal"
              :duration="3000"
              :autoplay="true"
              style="color: #6f97fa"
            ></countTo>명이 무료체험 중이에요.
          </p>
          <a class="apply" @click="apply">체험 신청하기</a>
        </div>
      </div>
      <suggestion v-show="suggestions.length"></suggestion>
    </section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Step from '../Step'
import Suggestion from './Suggestion'
import AppFooter from '../../AppFooter'
import {convertProductNameFrom} from '../../../modules/products'
import countTo from 'vue-count-to'

const alertOptions = {title: '', size: 'sm', okLabel: '확인'}

export default {
  name: 'cart',
  components: { Step, Suggestion, AppFooter, countTo },
  mounted () {
    this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/free-trials/state/')
      .then((result) => {
        this.endVal = result.data.ON_FREE_TRIAL
      })

    var today = new Date()
    var nowTime = today.getHours()
    var minimumHour = 21
    var maxHour = 24
    if (minimumHour <= nowTime && nowTime <= maxHour) {
      setInterval(() => {
        this.show = !this.show
      }, 500)
    }
  },
  data () {
    return {
      endVal: 0,
      show: false
    }
  },
  methods: {
    removeItem: function (item) {
      this.$store.commit('removeItem', item)
    },
    async apply () {
      let eventInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/advertising/')
      if (eventInfo.status === 204) {
        this.$dialogs.alert('무료체험이 매진되었습니다. 곧 다시 모집할테니 걱정마세요!', alertOptions)
        return
      }
      let stockInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/' + eventInfo.data.id + '/stocks/')
      for (var i = 0; i < this.cartItems.length; i++) {
        for (var j = 0; j < stockInfo.data.results.length; j++) {
          if (stockInfo.data.results[j].product_id === this.cartItems[i].id) {
            if (stockInfo.data.results[j].available_quantity === 0) {
              let name = convertProductNameFrom(this.cartItems[i].id)
              this.$dialogs.alert(name + '는 품절되었습니다.', alertOptions)
              return
            }
          }
        }
      }
      this.$router.push({ name: 'Plan' })
    }
  },
  updated () {
    if (this.cartItems.length === 0) {
      this.$dialogs.alert('장바구니가 비었습니다.', alertOptions)
      this.$router.push('/')
    }
  },
  computed: {
    cartItems () {
      return this.$store.state.cartItems
    },
    suggestions () {
      return this.$store.state.suggestions
    },
    products () {
      return this.$store.state.products
    }
  }
}
</script>

<style scoped>

.btn-close {
  width: 13px;
  height: 13px;
}
.cart-container {
  padding-top: 100px;
  padding-bottom: 100px;
}
.cart-wrapper {
  background-color: #fafafa;
}
.m-cart-wrapper {
  background-color: #fafafa;
  padding: 30px;
}
.m-cart-wrapper .m-left-info {
  display: flex;
  align-items: center;
}
.m-cart-wrapper .m-left-info :nth-child(2) {
  font-size: 14px;
  text-align: left;
}

.m-cart-wrapper .m-image-container {
  width: 50px;
}

.m-cart-item {
  margin-top: 12px;
  padding:15px;
  width: 100%;
  height: 110px;
  background-color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 1px 0 #e9ecee;
  border: solid 0.5px #f1f5f7;
}

.m-description {
  color: #85888b;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 1.67;
}
.m-mid-item-info {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 110px;
  margin-left: -25%;
}
@media (max-width: 320px) {
  .m-mid-item-info {
    margin-left: -16%;
  }
}
.m-mid-item-info p {
  margin: 0;
}

.cart-item {
  display: flex;
  align-items: center;
  margin-top: 12px;
  justify-content: space-between;
  background-color: #ffffff;
  box-shadow: 0 1px 1px 0 #e9ecee;
  border: solid 0.5px #f1f5f7;
  height: 126px;
  border-radius: 4px;
  cursor: pointer;
}

.cart-item .left-item-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  font-size: 16px;
}

.cart-item .left-item-info span {
  margin-left: 20px;
}
.cart-item .right-item-info {
  padding: 30px;
  font-size: 16px;
}
.cart-item .right-item-info :nth-child(1) {
  margin-right: 40px;
}
.item-info {
  text-align: left;
}
.item-info .description {
  color: #85888b;
  border-top: 0.5px solid #e7ecee;
  border-bottom: 0.5px solid #e7ecee;
  padding: 11px;
  margin-top: 15px;
  font-size: 12px;
  letter-spacing: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.m-item-info {
  margin-top: 45px;
  text-align: left;
}

.amount-info {
  display: flex;
  justify-content: space-between;
}
.amount-info :nth-child(1) {
  font-size: 12px;
  letter-spacing: 0;
}
.amount-info :nth-child(2) {
  font-size: 20px;
  letter-spacing: 0;
}

.m-amount-info {
  display: flex;
  justify-content: space-between;
  border-bottom: 0.5px solid #e7ecee;
  align-items: center;
}
.m-amount-info :nth-child(1){
  font-size: 12px;
}
.m-amount-info :nth-child(2){
  font-size: 20px;
  font-weight: bold;
}
.apply {
  width: 100%;
  height: 50px;
  position: relative;
  vertical-align: middle;
  font-family: "Noto Sans KR", sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  color: #ffffff !important;
  background-color: #6f97fa;
  border-radius: 2px;
  text-decoration: none;
  margin-top: 30px;
  display: inline-block;
  line-height: 28px;
}

 .apply:hover {
  background-color: #5686fe;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/apply/cart/Cart.vue